import React, { Component } from 'react'
import { Row, Col, Alert, Button, Spin, Icon, Switch } from 'antd'
import RolesModel from '../models/RolesModel'
import PoliciesModel from '../models/PoliciesModel'
import LoadingComponent from '../components/Loading'

class AdminActionsForm extends Component {

    constructor(props) {
        super(props)
        this.loadOptions = this.loadOptions.bind(this)
        this.loading = this.loading.bind(this)
        this.updateForm = this.updateForm.bind(this)
        this.onChangeAccess = this.onChangeAccess.bind(this)
        this.state = {
            ...this.props.data,
            loading: true,
            roles: [],
            sysPolicies: []
        }
    }

    loadOptions() {
        this.loading()
        RolesModel.findAll((roles) => {
            PoliciesModel.findAll((policies) => {
                var state = Object.assign({}, this.state)
                state.roles = roles
                state.sysPolicies = policies
                state.loading = false
                this.setState(state)
            })
        })
    }

    componentDidMount() {
        this.loadOptions()
    }

    componentWillReceiveProps(nextProps) {
        var state = {
            ...this.state,
            ...nextProps.data
        }
        this.setState(state)
    }

    updateForm(field, value) {
        const formData = this.state
        formData[field] = value
        this.setState(formData)
    }

    loading() {
        var state = Object.assign({}, this.state)
        state.loading = true
        this.setState(state)
    }

    onChangeAccess(id, checked) {
        var nextState = Object.assign({}, this.state)
        nextState.access[id] = {id, access: checked}
        this.setState(nextState)
    }

    onChangePolicy(id, checked) {
        var nextState = Object.assign({}, this.state)
        checked ? nextState.policies[id] = {id} : delete nextState.policies[id]
        this.setState(nextState)
    }

    render() {
        if (this.state.loading) return (<LoadingComponent />)
        return (
            <Row>
                <Col span={24}>
                    <form method="post" onSubmit={(e) => {
                        e.preventDefault()
                        this.props.storeItem(this.state)
                    }}>
                        <input type="hidden" ref="id" value={this.state.id} />

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <legend>{this.state.id ? 'Alterar Ação Implementada' : 'Registar Ação Implementada'}</legend>
                            </Col>
                        </Row>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="schema" className="ant-form-item-required" title="Namespace">
                                    Namespace
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <input id="schema"
                                    type="text"
                                    required="required"
                                    className="ant-input"
                                    value={this.state.schema}
                                    ref="schema"
                                    onChange={(e) => this.updateForm('schema', e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="action" className="ant-form-item-required" title="Nome do Perfil">
                                    Ação
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <input id="action"
                                    type="text"
                                    required="required"
                                    className="ant-input"
                                    value={this.state.action}
                                    ref="rolename"
                                    onChange={(e) => this.updateForm('action', e.target.value)}
                                />
                            </div>
                        </div>

                        { this.state.id ? (
                            <div>
                                <Row style={{marginBottom: '20px'}}>
                                    <Col xs={24} sm={6}></Col>
                                    <Col xs={24} sm={14}>
                                        <legend>Acesso</legend>

                                        <table style={{width: '100%', textAlign: 'left'}}>
                                            <thead>
                                                <tr>
                                                    <th>Perfil</th>
                                                    <th style={{width: '100px'}}>Autorizado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                { this.state.roles.map((item) => (
                                                    <tr key={item.id}>
                                                        <td>{item.rolename}</td>
                                                        <td>
                                                            <Switch checked={this.state.access[item.sysname] ? this.state.access[item.sysname].access : false}
                                                            onChange={(v) => this.onChangeAccess(item.sysname, v)} />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={24} sm={6}></Col>
                                    <Col xs={24} sm={14}>
                                        <legend>Políticas de Grupo</legend>

                                        <table style={{width: '100%', textAlign: 'left'}}>
                                            <thead>
                                                <tr>
                                                    <th>Etiqueta</th>
                                                    <th style={{width: '100px'}}>Activo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                { this.state.sysPolicies.map((item) => (
                                                    <tr key={item.id}>
                                                        <td>{item.label}</td>
                                                        <td>
                                                            <Switch checked={this.state.policies[item.id] ? true : false}
                                                            onChange={(v) => this.onChangePolicy(item.id, v)} />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>
                            </div>
                        ) : ''}

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <Alert className={this.props.complete && this.props.error ? '' : 'hidden'}
                                    message="Erro"
                                    description={this.props.error}
                                    type="error"
                                    showIcon
                                />
                                <Alert className={this.props.complete && !this.props.error ? '' : 'hidden'}
                                    message="Sucesso!"
                                    description="O perfil foi guardado com sucesso."
                                    type="success"
                                    showIcon
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                                    <button type="submit" className="ant-btn ant-btn-primary"
                                        disabled={this.state.loading && !this.props.complete}
                                        style={{float: 'right'}}>
                                        { this.state.loading  && !this.props.complete ? (<Spin />) : (<Icon type="save" />) }
                                        {' '}<span>Guardar</span>
                                    </button>
                                    <Button type="danger" onClick={(e) => this.props.history.push('/admin/actions')}>
                                        Cancelar
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                    </form>
                </Col>
            </Row>
        )
    }
}

export default AdminActionsForm;



// WEBPACK FOOTER //
// ./src/components/AdminActionsForm.js